
import { useState } from "react";
import { toast } from "sonner";
import { deleteAssessment } from "../api/folderApi";
import { handleAssessmentError, notifySuccess } from "../utils/errorHandlers";
import { useBaseMutation } from "./useBaseMutation";

export const useDeleteAssessment = (
  onAssessmentDeleted: (assessmentId: string) => void
) => {
  const { isLoading, error, startLoading, setSuccess, setFailure } = useBaseMutation();
  
  const handleDeleteAssessment = async (assessmentId: string): Promise<void> => {
    console.log("🗑️ DELETE ATTEMPT:", { assessmentId });
    
    if (!confirm("Är du säker på att du vill ta bort denna riskbedömning? Alla data kommer att raderas permanent och kan inte återställas.")) {
      console.log("🚫 DELETE CANCELLED by user");
      return;
    }
    
    console.log("✅ DELETE CONFIRMED, proceeding...");
    startLoading();

    try {
      console.log("🔄 Calling deleteAssessment API...");
      await deleteAssessment(assessmentId);
      console.log("✅ DELETE API SUCCESS, calling onAssessmentDeleted...");
      onAssessmentDeleted(assessmentId);
      notifySuccess("Riskbedömningen har tagits bort permanent");
      setSuccess();
      console.log("🎉 DELETE PROCESS COMPLETED");
    } catch (error: any) {
      console.error("❌ DELETE ERROR:", error);
      
      if (error.code === 'PGRST116') {
        // Assessment not found, but we can still remove it from UI
        console.log("⚠️ Assessment not found in DB, removing from UI anyway");
        toast.error("Riskbedömningen finns inte längre");
        onAssessmentDeleted(assessmentId);
        setSuccess();
        return;
      }
      
      const errorMessage = handleAssessmentError(error, "Kunde inte ta bort riskbedömningen");
      console.error("💥 FINAL DELETE ERROR:", errorMessage);
      setFailure(errorMessage);
      toast.error(errorMessage);
    }
  };

  return {
    isLoading,
    error,
    handleDeleteAssessment
  };
};
